/**
 * Where authentication happens.
 *
 * Laravel owns the accounts, the passkeys and the tokens; the webapp backend
 * only checks the token it is handed. Auth calls therefore go here, not to
 * API_URL -- a passkey registered against one stack is worthless to the other,
 * because they answer on different rp.ids.
 *
 * Empty in production: Laravel sits behind the same nginx as this app.
 */
export const AUTH_URL = import.meta.env.VITE_LARAVEL_URL || '';
